import { API, API_BASE } from '../config/api';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Music, ShoppingBag, Headphones, ExternalLink } from 'lucide-react';
import axios from 'axios';
import { ShareQRButton, InstallAppButton } from '../components/ShareQR';


const SOCIAL_LINKS = [
  { name: 'Instagram', url: 'https://www.instagram.com/DraiMoe', icon: 'instagram', color: '#E1306C' },
  { name: 'Facebook', url: 'https://www.facebook.com/DraiMoeTLC', icon: 'facebook', color: '#1877F2' },
  { name: 'X (Twitter)', url: 'https://www.x.com/DraiMoe', icon: 'x', color: '#FFFFFF' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/drai-m-98876726', icon: 'linkedin', color: '#0A66C2' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@draimoe', icon: 'tiktok', color: '#00F2EA' },
  { name: 'YouTube', url: 'https://www.youtube.com/DreMoeBayBee', icon: 'youtube', color: '#FF0000' },
  { name: 'SoundCloud', url: 'https://www.soundcloud.com/DraiMoe', icon: 'soundcloud', color: '#FF5500' },
  { name: 'UnitedMasters', url: 'https://unitedmasters.com/DraiMoe', icon: 'music', color: '#DAA520' },
];

const SITE_LINKS = [
  { name: 'Stream My Music', href: '/#music', icon: Music, color: '#FF3B30' },
  { name: 'Buy Beats', href: '/#beats', icon: Headphones, color: '#DAA520' },
  { name: 'Shop Merch', href: '/#merch', icon: ShoppingBag, color: '#FF3B30' },
];

const SocialIcon = ({ type, size = 20 }) => {
  const icons = {
    instagram: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
    facebook: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    x: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    linkedin: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    tiktok: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    youtube: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    soundcloud: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.009-.06-.05-.1-.1-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.172 1.282c.013.06.045.094.104.094.057 0 .09-.035.104-.094l.21-1.282-.21-1.332c-.014-.057-.047-.094-.104-.094m1.837-1.585c-.064 0-.107.045-.112.107l-.229 2.905.229 2.835c.005.062.048.107.112.107.064 0 .107-.045.113-.107l.26-2.835-.26-2.905c-.006-.062-.05-.107-.113-.107m.9-.69c-.067 0-.117.05-.123.117l-.217 3.595.217 3.435c.006.067.056.117.123.117s.117-.05.123-.117l.248-3.435-.248-3.595c-.006-.067-.056-.117-.123-.117m.924-.54c-.072 0-.127.057-.131.127l-.2 4.135.2 3.9c.004.072.059.127.131.127.071 0 .126-.055.132-.127l.227-3.9-.227-4.135c-.006-.07-.061-.127-.132-.127m.916-.439c-.074 0-.131.06-.137.137l-.186 4.574.186 4.155c.006.075.063.137.137.137.075 0 .131-.062.138-.137l.212-4.155-.212-4.574c-.007-.077-.063-.137-.138-.137m.93-.3c-.079 0-.139.066-.144.146l-.174 4.874.174 4.28c.005.08.065.146.144.146.079 0 .14-.066.145-.146l.197-4.28-.197-4.874c-.005-.08-.066-.146-.145-.146m.94-.158c-.083 0-.148.07-.153.156l-.16 5.032.16 4.36c.005.084.07.156.153.156.082 0 .147-.072.153-.156l.183-4.36-.183-5.032c-.006-.086-.07-.156-.153-.156m.94 0c-.088 0-.155.078-.16.166l-.147 5.032.147 4.404c.005.088.072.166.16.166.087 0 .154-.078.16-.166l.167-4.404-.168-5.032c-.005-.088-.072-.166-.16-.166m.93.07c-.09 0-.16.08-.165.175l-.135 4.962.135 4.417c.005.094.075.175.165.175.09 0 .16-.08.166-.175l.155-4.417-.155-4.962c-.006-.095-.076-.175-.166-.175m.94-.023c-.094 0-.166.088-.172.186l-.12 4.985.12 4.43c.006.098.078.186.172.186.094 0 .166-.088.172-.186l.14-4.43-.14-4.985c-.006-.098-.078-.186-.172-.186m2.83 1.472c-.3 0-.59.04-.87.115-.18-2.025-1.89-3.61-3.97-3.61-.54 0-1.065.115-1.53.317-.175.076-.222.153-.225.303v8.57c.003.155.13.282.283.297h6.312c1.31 0 2.375-1.065 2.375-2.375 0-1.31-1.065-2.375-2.375-2.375"/>
      </svg>
    ),
    music: (
      <Music size={size} />
    ),
  };
  return icons[type] || <ExternalLink size={size} />;
};

export default function Links() {
  const [heroImage, setHeroImage] = useState(null);
  const [appButtonSettings, setAppButtonSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then(({ data }) => {
      if (data?.links_profile_image) setHeroImage(data.links_profile_image);
      else if (data?.hero_image) setHeroImage(data.hero_image);
      if (data?.app_button) setAppButtonSettings(data.app_button);
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="links-page">
      <Helmet>
        <title>DraiMoe — Links | IOMSL</title>
        <meta name="description" content="All of DraiMoe's links in one place. Music, beats, merch, socials." />
      </Helmet>

      <div className="max-w-md mx-auto px-4 py-12">
        {/* Profile Header */}
        <div className="text-center mb-10">
          <div className="w-24 h-24 mx-auto mb-4 border-2 border-[#DAA520] overflow-hidden rounded-full" data-testid="links-profile-image">
            {heroImage && (
              <img
                src={heroImage}
                alt="DraiMoe"
                className="w-full h-full object-cover"
              />
            )}
          </div>
          <h1 className="font-cabinet text-2xl font-black uppercase tracking-tight" data-testid="links-title">
            DRAIMOE
          </h1>
          <p className="text-[#A3A3A3] text-sm mt-1">I'M ON MY 2ND LIFE</p>
          <div className="w-12 h-0.5 bg-[#DAA520] mx-auto mt-3" />
        </div>

        {/* Site Links */}
        <div className="space-y-3 mb-8" data-testid="site-links">
          {SITE_LINKS.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="flex items-center gap-4 w-full p-4 border border-[#262626] hover:border-[#FF3B30] bg-[#141414] transition-all hover:translate-x-1 group"
              data-testid={`link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
            >
              <link.icon size={20} style={{ color: link.color }} />
              <span className="font-bold text-sm uppercase tracking-wider flex-1">{link.name}</span>
              <ExternalLink size={14} className="text-[#666] group-hover:text-white transition-colors" />
            </Link>
          ))}
        </div>

        {/* Social Links */}
        <div className="space-y-3 mb-10" data-testid="social-links">
          <p className="overline text-[#666] text-xs mb-4 text-center tracking-widest">CONNECT WITH ME</p>
          {SOCIAL_LINKS.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 w-full p-4 border border-[#262626] hover:border-[#DAA520] bg-[#141414] transition-all hover:translate-x-1 group"
              data-testid={`social-${link.icon}`}
            >
              <span style={{ color: link.color }}>
                <SocialIcon type={link.icon} size={20} />
              </span>
              <span className="font-bold text-sm uppercase tracking-wider flex-1">{link.name}</span>
              <ExternalLink size={14} className="text-[#666] group-hover:text-white transition-colors" />
            </a>
          ))}
        </div>

        {/* Footer */}
        <div className="text-center pt-6 border-t border-[#262626] space-y-6">
          {(!appButtonSettings || (appButtonSettings.enabled !== false && appButtonSettings.show_in_links !== false)) && (
            <InstallAppButton variant="full" settings={appButtonSettings} />
          )}
          <ShareQRButton variant="links" />
          <Link to="/" className="text-[#666] hover:text-[#DAA520] text-xs uppercase tracking-widest transition-colors block" data-testid="links-home">
            iomsl.com
          </Link>
        </div>
      </div>
    </div>
  );
}
